import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { apiConstants } from "../../common/constants";
import { decodeAuthToken } from "../../common/util"
import _ from 'lodash';

export const userLoginGoogle = createAsyncThunk(
    'auth/signin',

    async ({code, navigate }, { rejectWithValue }) => {
        try {
            const config = { headers: { 'Content-Type': 'application/json' } };
            const validateURL = `${apiConstants.BASE_LOCAL}${apiConstants.VALIDATE_GOOGLE_AUTH_CODE}`;
            const {data} = await axios.get(validateURL+"?code="+code)
            localStorage.setItem('userToken', data.accessToken);
            if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
            const d = decodeAuthToken(data.accessToken)
            config.headers.Authorization = `Bearer ${data.accessToken}`
            let merchantData;
            const VerifiedRole = _.intersection(d.roles, ["ROLE_PROSHIPADMIN"])
            if (VerifiedRole.length > 0) {
                try {
                    let loginUrl = apiConstants.BASE_LOCAL + apiConstants.MERCHANT_SEARCH;
                    const { data } = await axios.post(loginUrl, { "offset": 0, "limit": 1, "orfilter": [], "andfilter": [{ "field": "id", "operator": "eq", "value": d.merchantOid }], "excludes": "mappedOrderRule,sla,codRemittanceConfig" }, config)
                    merchantData = data.data[0];
                    delete merchantData.codRemittanceConfig
                    delete merchantData.mappedOrderRule
                    delete merchantData.wallet
                } catch (err) { 
                    console.log('error')
                }
                console.log({ ...data, merchant: merchantData })
                return { ...data, merchant: merchantData }
            }
            else {
                navigate("/unAuthorized");
                return rejectWithValue("No roles assigned to this user")
            }
        } catch (error) {
            console.log(error);
            if (error.response.status >= 500 || error.response.status === 499) {
                return rejectWithValue("Server Error")
            }
            if (error.response.status === 401 || error.response.status === 400 ) {
                navigate("/unAuthorized");
                return rejectWithValue("Incorrect username or password")
            }
            else {
                return rejectWithValue(error?.response?.data || error.message)
            }
        }
    }
);